import { createApp } from "vue";
import App from "./App.vue";

/**
 * Creates an instance of the delivery date reactive application.
 *
 * This application is a direct replacement of the old `_configrator-date-radios` with a lot of custom elements
 * injected into the dom with custom scripting.
 *
 * ## Options
 * This component works by generating x days ahead of today. The amount of days ahead are supplied by the editor and are
 * passed on dataset to the host element.
 *
 * The following options are available
 *
 * - Array<number> enabledDays: Array of days of the week Sunday to Saturday 0 -> 7
 * - Array<string> disabledDates: Array of yyyy-mm-dd formatted dates that should be disabled even if in `enabledDays` array
 * - Array<string> forceEnabledDates: Array of yyyy-mm-dd formatted dates that should be enabled even if not `enabledDays` array
 * - boolean todayOpen: Server side calculation if the store is still open today.
 * - number daysInAdvance: The amount of additional days to render. min 4, max 99
 * - string labelTemplateSelector: The HTMLElement CSS selector for the label template.
 * - string customerDateFormatCart: The date format for the customer in the cart.
 *
 * ## Generation of days
 * Using the `daysInAdvance` config setting we will get an amount of dates to render radios for. This used to not take
 * the current day in account if today is closed, but in the new state it should.
 */
export function createDeliveryDateApp(): void {
	const app = createApp(App);

	app.mount("#delivery-date");
}
